import axios from "axios";

const Gfunc = require("../Gfunc");

export const getBinars = async () => {
  let res = null;
  const response = await Gfunc.axiosGetAction("_irh.php", "getbinars");
  if (response.data.err && response.data.err !== "-1") return response;
  Gfunc.axiosResponse(response, () => {
    res = response;
  });
  return res;
};

export const Caisse = async () => {
  const response = await Gfunc.axiosGetAction("_cai.php", "getcaisse");
  Gfunc.updateElem("caisseMtn", response.data.jData);
  Gfunc.updateElem("caisseMtn2", response.data.jData);
};

//fetch fournisseurs
export const fetchFrns = async (serv = "_frs.php", act = "gets") => {
  const response = await Gfunc.axiosGetAction(serv, act);
  Gfunc.axiosResponse(response, () => {
    return response.data.jData;
  });
};

//fetch users
export const fetchUser = async (serv = "_usr.php", act = "gets") => {
  const response = await Gfunc.axiosGetAction(serv, act);
  Gfunc.axiosResponse(response, () => {
    return response.data.jData;
  });
};

const API_BASE_URL = "https://mobile-pre.at.dz/api/paiement";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// 🔹 Vérifier une ligne ADSL
// export const getIdoomLineOffer = async (tel) => {
//   try {
//     const response = await api.post("/checkNdAdsl", {
//       nd: tel,
//       service: "Voucher",
//     });

//     if (response.data.code === "1") {
//       response.data.message = "Numéro Incorrect";
//     }
//     console.log(response)
//     return response.data;
//   } catch (error) {
//     return { message: "Problème de connexion" };
//   }
// };

// 🔹 Utiliser une carte ADSL
// export const useIdoomCard = async ({ nd, ncli, type }) => {
//   try {
//     const voucher = "1722639052275903"; // Exemple, à récupérer dynamiquement
//     const response = await api.post("/voucherAdsl", {
//       nd,
//       ncli,
//       type,
//       voucher,
//       ip: "0.0.0.0",
//     });

//     // Remplacement des messages codés
//     switch (response.data.message) {
//       case "118100443":
//         response.data.message = "Carte non existante";
//         break;
//       case "118100155":
//         response.data.message = "Carte déjà utilisée";
//         break;
//     }

//     return response.data;
//   } catch (error) {
//     return { message: "Problème de connexion" };
//   }
// };
// 🔹 Vérifier une ligne 4G
export const getIdoomLineOffer = async (tel, lte) => {
  try {
    const response = await Gfunc.axiosPostAction("_irh.php", "atvrf", {
      tel: tel,
      lte: lte,
    });
    return response.data;
  } catch (error) {
    return { message: "Problème de connexion" };
  }
};

// 🔹 Utiliser une carte 4G
export const useIdoomCard = async ({ tel, lte, ncli, type }) => {
  try {
    const response = await Gfunc.axiosPostAction("_irh.php", "atcnf", {
      tel: tel,
      lte: lte,
      ncli: ncli,
      typ: type,
    });
    return response.data;
  } catch (error) {
    return { message: "Problème de connexion" };
  }
};
